var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"feedforwardError"}},[_c('el-card',{style:({width: _vm.dialogWidth}),attrs:{"shadow":"hover"}},[_vm._v(" "+_vm._s(_vm.errorText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }